// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/send_to_donna.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ResponseStatus } from "./util/response_status_pb.js";

/**
 * @generated from message knop.ui.v1.api.SendToDonnaRequest
 */
export class SendToDonnaRequest extends Message<SendToDonnaRequest> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  constructor(data?: PartialMessage<SendToDonnaRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.SendToDonnaRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendToDonnaRequest {
    return new SendToDonnaRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendToDonnaRequest {
    return new SendToDonnaRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendToDonnaRequest {
    return new SendToDonnaRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendToDonnaRequest | PlainMessage<SendToDonnaRequest> | undefined, b: SendToDonnaRequest | PlainMessage<SendToDonnaRequest> | undefined): boolean {
    return proto3.util.equals(SendToDonnaRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.SendToDonnaResponse
 */
export class SendToDonnaResponse extends Message<SendToDonnaResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<SendToDonnaResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.SendToDonnaResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendToDonnaResponse {
    return new SendToDonnaResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendToDonnaResponse {
    return new SendToDonnaResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendToDonnaResponse {
    return new SendToDonnaResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendToDonnaResponse | PlainMessage<SendToDonnaResponse> | undefined, b: SendToDonnaResponse | PlainMessage<SendToDonnaResponse> | undefined): boolean {
    return proto3.util.equals(SendToDonnaResponse, a, b);
  }
}

